__turbopack_context__.v({
  "caret": "yXRsUq_caret",
  "menu": "yXRsUq_menu",
  "option": "yXRsUq_option",
  "optionActive": "yXRsUq_optionActive",
  "positioner": "yXRsUq_positioner",
  "sortByLabel": "yXRsUq_sortByLabel",
  "sortGroup": "yXRsUq_sortGroup",
  "trigger": "yXRsUq_trigger",
});
